<template>
  <div class="row" style="text-align:left; color: #fff;" v-if="sets.length > 0">
    <!-- color:rgb(49, 57, 76) -->
    <div class="col-12 nopadd" style="padding-left: 10px;">
      <div class="row menuel pdt10">
        <div
          class="col-12 fz22 nopadd"
          v-b-toggle="'innrMenu' + sets[0].category + (sets[0].isActive ? '' : '-old')"
        >{{sets[0].category.substring(0,1).toUpperCase()}}{{sets[0].category.substring(1)}}</div>
      </div>
      <b-collapse :id="'innrMenu' + sets[0].category + (sets[0].isActive ? '' : '-old')">
        <!-- class="mt025" -->
        <div class="row" v-for="(set, ind) in sets" :key="ind">
          <div class="col-12 pdr0">
            <div class="row menuel pdt5">
              <div
                class="col-9 fz18 fbold pdr0"
                v-b-toggle="'innrMenu-' + set.category + '-' + ind + (set.isActive ? '' : '-old')"
              >{{set.title}}</div>
            </div>
            <b-collapse
              :id="'innrMenu-' + set.category + '-' + ind + (set.isActive ? '' : '-old')"
              class="mt025"
            >
              <div
                class="row menuel"
                v-if="!(set.type == 'confirmation' && set.category == 'appointment') && set.isActive"
                @click="select.sent=false; select.msId = set.msId"
              >
                <div class="col-1" style="padding: 5px;"></div>
                <div
                  :class="['col-11', 'mt015', 'schedEl', isGSelected == set.msId && !select.sent ? 'coloryel' : '']"
                >Scheduled</div>
              </div>

              <div @click="select.sent = true; select.msId = set.msId" class="row menuel">
                <div class="col-1" style="padding: 5px;"></div>
                <div
                  :class="['col-11', 'mt015','schedEl', isGSelected == set.msId && select.sent ? 'coloryel' : '']"
                >Sent</div>
              </div>
            </b-collapse>
          </div>
        </div>
      </b-collapse>
      <div style="margin-top: 10px;">
        <hr class="style-one" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RemMenu",
  components: {},
  props: {
    sets: Array,
    isGSelected: String
  },
  data() {
    return {
      select: {
        msId: null,
        sent: null
      },
      selected: {
        category: null,
        type: null,
        sent: null
      }
    };
  },
  watch: {
    isGSelected: function(v) {
      if (v != this.select.msId) {
        this.select.sent = null;
      }
    },
    select: {
      deep: true,
      handler(val) {
        if (this.sets.find(el => el.msId == val.msId)) {
          this.$emit("menuchange", val);
        }
      }
    }
  }
};
</script>
<style>
.pd10 {
  padding: 10px;
}
.pdr0 {
  padding-right: 0;
}
.schedEl:hover {
  background: rgba(58, 77, 145, 0.05);
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.coloryel {
  color: yellow;
  /* color: rgb(49, 57, 76); */
  /* color: #266db3; */
  background-color: #2b5278;

  /* background: rgb(77, 99, 179, 0.15); */
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.fbold {
  font-weight: bold;
}
.schedEl {
  line-height: 1.5;
  /* font-size: 18px; */
  /* padding: 10px; */
}
.nopadd {
  padding: 0;
}
.menuel {
  cursor: pointer;
}
.pdt10 {
  margin-top: 10px;
}
.pdt5 {
  margin-top: 0.5rem;
}
.fz22 {
  font-size: 16px;
  font-weight: bold;
}
.fz18 {
  /* font-size: 18px; */
}
hr.style-one {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}
.mt025 {
  margin-top: 0.25rem !important;
}
.mt015 {
  margin-top: 0.15rem !important;
}
</style>